import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const ZalopayResultMob = () => {
  return <CommonResult />;
};

export default ZalopayResultMob;
